import { schema } from 'normalizr'

const templateSchema = new schema.Entity('template')
templateSchema.define({})

const controlSchema = new schema.Entity('control')
controlSchema.define({})

export { templateSchema, controlSchema }
